import { useTranslation } from "next-i18next";
import { useMemo } from "react";

import { RouteName } from "@/consts/RouteName";
import { useFeatureEnabled } from "@/features/common/hooks/useFeatureEnabled";
import { FeatureNameEnum } from "@/generated/generated-hooks";

import { SettingMenuItemProps } from "../components/setting/SettingMenuItem";

export function useSettingMenuItems() {
  const { t } = useTranslation(["profileNavigation", "common"]);
  const { isEnabled } = useFeatureEnabled();
  const isNFTEnabled = isEnabled(FeatureNameEnum.Nft);

  const items: SettingMenuItemProps[] = useMemo(() => {
    const nftRelatedMenu = isNFTEnabled
      ? [
          {
            label: t("common:pageNavigation.collectibles"),
            route: RouteName.CollectibleRoute,
            subPaths: [
              {
                label: t("profileNavigation:collectibles.myCollectibles"),
                path: RouteName.CollectibleMe,
              },
              {
                label: t("profileNavigation:collectibles.purchased"),
                path: RouteName.CollectiblePurchased,
              },
              {
                label: t("profileNavigation:collectibles.myFavourites"),
                path: RouteName.CollectibleFavourites,
              },
              {
                label: t("profileNavigation:collectibles.royaltyPayments"),
                path: RouteName.CollectibleRoyalty,
              },
            ],
          },
        ]
      : [];

    return [
      {
        label: t("profileNavigation:mySettings.editProfile"),
        route: RouteName.MySettingsProfile,
      },
      {
        label: t("common:pageNavigation.myFollowing"),
        route: RouteName.MyFollowingUser,
      },
      {
        label: t("common:pageNavigation.myAudience"),
        route: RouteName.MyAudienceUser,
      },
      {
        label: t("common:pageNavigation.accountSetting"),
        route: RouteName.MySettingsAccount,
      },
      ...nftRelatedMenu,
    ];
  }, [t, isNFTEnabled]);

  return items;
}
